export const disableActionsByDefault = (columnId: string) => {
  return (
    columnId === 'data-execucao-id' ||
    columnId === 'cd-loja-codigo-id' ||
    columnId === 'gerente-categoria-id' ||
    columnId === 'gerente-produto-id' ||
    columnId === 'mundo-codigo-id' ||
    columnId === 'mundo-nome-id' ||
    columnId === 'categoria-compacta-codigo-id' ||
    columnId === 'categoria-compacta-nome-id' ||
    columnId === 'categoria-codigo-id' ||
    columnId === 'categoria-nome-id' ||
    columnId === 'status-nome-id' ||
    columnId === 'curva-abc-nome-id' ||
    columnId === 'empresa-codigo-id' ||
    columnId === 'empresa-nome-id' ||
    columnId === 'fornecedor-nome-id' ||
    columnId === 'ruptura-one-day-id' ||
    columnId === 'ruptura-one-total-id' ||
    columnId === 'ruptura-one-sku-id'
  )
}
